import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Box, Typography } from '@mui/material';

// Fix for Leaflet marker icons
// This is needed because of how webpack handles assets
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Custom marker icon colors
const createColoredIcon = (color) => {
  return new L.Icon({
    iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-${color}.png`,
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
};

const LocationMap = ({ locationData, title, color = 'blue' }) => {
  // Try to parse the location data if it's a string
  let position = null;
  let locationDetails = null;
  
  try {
    if (typeof locationData === 'string') {
      locationDetails = JSON.parse(locationData);
    } else {
      locationDetails = locationData;
    }
    
    // Extract lat and lng
    if (locationDetails.lat && locationDetails.lng) {
      position = [locationDetails.lat, locationDetails.lng];
    } else if (locationDetails.passed_location && locationDetails.passed_location.lat && locationDetails.passed_location.lng) {
      position = [locationDetails.passed_location.lat, locationDetails.passed_location.lng];
    }
  } catch (error) {
    console.error("Error parsing location data:", error);
  }
  
  const icon = createColoredIcon(color);
  
  // If we couldn't get a valid position, show an error message
  if (!position) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography color="error">Invalid location data</Typography>
        <Typography variant="body2" color="text.secondary">
          {JSON.stringify(locationData)}
        </Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ height: 200, width: '100%', borderRadius: 2, overflow: 'hidden' }}>
      <MapContainer 
        center={position} 
        zoom={13} 
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position} icon={icon}>
          <Popup>
            <Typography variant="subtitle2">{title}</Typography>
            <Typography variant="body2">
              Latitude: {position[0].toFixed(6)}<br />
              Longitude: {position[1].toFixed(6)}
            </Typography>
            {locationDetails.city && (
              <Typography variant="body2">City: {locationDetails.city}</Typography>
            )}
            {locationDetails.areaId && (
              <Typography variant="body2">Area ID: {locationDetails.areaId}</Typography>
            )}
          </Popup>
        </Marker>
      </MapContainer>
    </Box>
  );
};

export default LocationMap; 